import React, { useState } from 'react';
import { FormField, TextArea, Toggle } from '@fashionnovateam/nova-ui-toolkit';
import {
  FormErrors,
  PurchaseOrderRevisionForm,
  UpdatePurchaseOrderRevisionForm,
} from './validation';
import { PurchaseOrderLine } from '../../../Lib/Types/purchase-order';
import { OtherId } from './formTargetId';
import { ExcludeSpecialCharacters } from '../../../Lib/Constants/regexes';

type ItemCommentFormProps = {
  item: NonNullable<PurchaseOrderRevisionForm['items']>[0];
  index: number;
  lines: PurchaseOrderLine[];
  styleColor: string;
  name: string;
  updateForm: UpdatePurchaseOrderRevisionForm;
  disabled: boolean;
  errors: FormErrors | undefined;
};

export function ItemCommentForm(props: ItemCommentFormProps) {
  const { styleColor, item, index, errors, disabled, updateForm } = props;
  const [formPrevValue, setFormPrevValue] = useState('');

  const getComment = (checked: boolean, comment: string | undefined) => {
    if (checked) {
      return formPrevValue;
    }
    if (comment !== undefined) {
      setFormPrevValue(comment);
    }
    return undefined;
  };

  return (
    <div className="flex flex-col gap-5" id={`${OtherId}-${index}`}>
      <div className="flex items-center gap-3">
        <Toggle
          onChange={(e) => {
            updateForm((prev) => ({
              ...prev,
              items: prev.items?.map((i) => {
                if (i.style_color !== styleColor) return i;
                return {
                  ...i,
                  comment: getComment(e.target.checked, i.comment),
                };
              }),
            }));
          }}
          checked={item.comment !== undefined}
          disabled={disabled}
        />
        <span className="text-sm font-medium text-base-primary">
          Other Changes
        </span>
      </div>
      {item.comment !== undefined && (
        <FormField
          label="Please detail what the changes are"
          required
          error={errors?.[`items.${index}.comment`]}
        >
          <TextArea
            value={item.comment}
            onChange={(e) => {
              updateForm((prev) => ({
                ...prev,
                items: prev.items?.map((i) => {
                  if (i.style_color !== styleColor) return i;
                  return {
                    ...i,
                    comment: e.target.value.replace(
                      ExcludeSpecialCharacters,
                      '',
                    ),
                  };
                }),
              }));
            }}
            error={!!errors?.[`items.${index}.comment`]}
            disabled={disabled}
          />
        </FormField>
      )}
    </div>
  );
}
